import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrgInfo } from "api/organisation";
import { Label } from "lib";
import { Row, Col } from "react-bootstrap";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";

const Esign = (props) => {
  const { formFields, setSelectedData, selectedData,formErr } = props;

  let toggleError = formErr['same_for_all']
  let signatureTypeError = formErr['signature_type']
  let authenticationModeError = formErr['authentication_mode']

  let toggleValue = selectedData['same_for_all']
  let signatureTypeValue = selectedData['signature_type']
  let verificationModeValue = selectedData['authentication_mode']

  const dispatch = useDispatch();

  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);

  const wfName = useSelector(
    (state) => state.configurationReducer.config.organisation_id
  );

  const [OrgEsignServices, setOrgEsignServices] = useState([""]);
  const [toggle, setToggle] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [subCategory, setSubCategory] = useState("");


  useEffect(() => {
      if(toggleValue){
        setToggle(toggleValue)
      }
      if(signatureTypeValue){
        setSelectedOption(signatureTypeValue)
      }
      if(verificationModeValue){
        setSubCategory(verificationModeValue)
      }
    },[toggleValue,signatureTypeValue,verificationModeValue])

  useEffect(() => {
    if (decryptedId)
    getOrgInfo({ _id: wfName }).then((res) => {
    setOrgEsignServices(res?.signature_services.map((value) => value.toLowerCase()))});
  }, [decryptedId]);

  const handleToggle = () => {
      setToggle(!toggle)
      dispatch(setSelectedData({ key: "same_for_all", value: !toggle }));
    setSelectedOption(null);
    setSubCategory(null);
    dispatch(setSelectedData({ key: "signature_type", value: '' }));
    dispatch(setSelectedData({ key: "authentication_mode", value: '' }));
  };


  const handleOptionChange = (category) => {
    setSelectedOption(category.toLowerCase());
    dispatch(setSelectedData({ key: "signature_type", value: category }));
    setSubCategory(null);
    dispatch(setSelectedData({ key: "authentication_mode", value: '' }));
  };

  const handleSubCategoryChange = (option) => {
    setSubCategory(option);
    if(selectedData?.signature_type == "electronic"){
    dispatch(setSelectedData({ key: "authentication_mode", value: option }));
    }else if(selectedData?.signature_type == "vbec"){
    dispatch(setSelectedData({ key: "authentication_mode", value: "both" }));
    dispatch(setSelectedData({ key: "document_verification_type", value: option }));
    }
    else{
      dispatch(setSelectedData({ key: "authentication_mode", value: "both" }));
    }

  };

  return (
    <>
      <div className={`toggle border p-4 .bg-theme-grey-2 `}>
        <div className="toggle_switch d-flex">
          <Label label="Do you wish choose the signing method?" isToggle='true' />
          <label className="toggle_switch_label">
            <input
              className={`toggle_switch_input`}
              type="checkbox"
              checked={toggle}
              id="same_for_all"
              onChange={handleToggle}
            />
            <div className="switch"></div>
          </label>
        </div>
        {!toggle && toggleError && <ErrorMessage error={toggleError?.err} />}  

        {toggle && (
          <>
            <Row>
              <Label
                label="Please choose the signature method"
                className="mb-3 mt-3"
              />
              {OrgEsignServices.filter((value) =>
                formFields.esign_allowed.includes(value.toLowerCase())
              ).map((option, index) => {
                const formattedOption = option.split("-").map((word) =>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");

                return (
                  <Col lg={6} md={6} sm={12} key={index} className="mb-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleOptionChange(option)}
                  >
                    <div className={"form-radio"}>
                      <input
                        id="signature_type"
                        type="radio"
                        className="radio_input"
                        label={formattedOption}
                        checked={selectedOption === option}
                        onChange={() => handleOptionChange(option)}
                        value={selectedOption}
                      />
                      <label className={`radio_label options px-2`}>
                        <div className="dot"></div>
                        <span>{formattedOption}</span>
                      </label>
                    </div>
                  </Col>
                );
              })}
            </Row>
          <Row>
            {toggle && !selectedOption && signatureTypeError &&  <ErrorMessage error={signatureTypeError?.err} />}  
          </Row>

            {selectedOption &&
              formFields.esign_sub_category[selectedOption] && (
                <>
                  <Label label="Choose Verification Type" isToggle='true'/>
                  <Row>
                    {formFields.esign_sub_category[selectedOption].map(
                      (category, index) => (
                        <Col lg={6} md={6} sm={12} key={index} className="mb-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSubCategoryChange(category)}
                        >
                          <div className={"form-radio"}>
                            <input
                              id="signature_type"
                              type="radio"
                              className="radio_input"
                              label={category}
                              checked={subCategory === category}
                              onChange={() => handleSubCategoryChange(category)}
                              value={subCategory}
                            />
                            <label className={`radio_label options px-2`}>
                              <div className="dot"></div>
                              <span>{category}</span>
                            </label>
                          </div>
                        </Col>
                      )
                    )}
                  </Row>
                </>
              )}
            <Row>
            {selectedOption && !subCategory && authenticationModeError &&  <ErrorMessage error={authenticationModeError?.err} />}
          </Row>
          </>
        )}
      </div>
    </>
  );
};

export default Esign;
